import navigationConfig from "../config/navigationConfig";
import { NavItem } from "../models/navItem";
import { toNavigationRole } from "../models/user/userRole";
import { authService } from "./auth.service";
import { userManagementService } from "./user-management.service";

export class NavigationService {

  // Private static instance of the class (singleton)
  private static instance: NavigationService;
  
  // Private constructor to prevent direct instantiation
  private constructor() {
  }

  // Method to return the singleton instance
  public static getInstance(): NavigationService {
    if (!NavigationService.instance) {
      NavigationService.instance = new NavigationService();
    }
    return NavigationService.instance;
  }

  // public getNavigationItems = (location: string, level = 0) => {
  //   return navigationConfig.filter(({ navigation }) => navigation && navigation.includes(location));

  //   // // Filter pages based on user role
  //   // const filteredPages = navigationConfig
  //   //   .filter(({ public: isPublic, roles, navigation }) => {
  //   //     if (!navigation.includes(location)) return false;
  //   //     if (isPublic) return true;
  //   //     return user && roles.includes(user.role);
  //   //   })
  //   //   .sort((a, b) => (a.order[location] || 99) - (b.order[location] || 99)); // Sort by order

  // };

  // public getNavigationItems = (location: string, user: AccountInfo | null): NavItem[] => {
  public getNavigationItems = async (location: string): Promise<NavItem[]> => {
    // const user: AccountInfo | null;
    const user = await authService.getAccount();
    const isAdmin = await authService.isAdmin();
    let userRole: string = '';
    if (isAdmin) {
      userRole = 'Admin';
    }
    else {
      const storedOrganisatie = userManagementService.getStoredOrganisatie();
      if (storedOrganisatie) {
        userRole = toNavigationRole(storedOrganisatie.userType);
      }
    }

    // console.log('userRole', userRole);

    return navigationConfig
      .filter(({ navigation }) => navigation && navigation.includes(location))
      .map((item) => ({
        ...item,
        children: item.children
          ? item.children
              .filter((child) => child.navigation.includes(location))
              .sort((a, b) => ((a.order && a.order[location]) || 99) - ((b.order && b.order[location]) || 99)) // Sort children
          : [],
      }))
      .filter(({ public: isPublic, roles, hideWhenAuthenticated }) => {
        // TEMP: Always show all pages for now
        // return true;

        if (isPublic && !hideWhenAuthenticated) return true; // Always show public pages unless `hideWhenAuthenticated`
        if (!user) return false; // Hide private pages if not logged in
        if (hideWhenAuthenticated && user) return false; // Hide "Inloggen" when logged in
        return roles.some((role) => userRole === role);
      })
      .sort((a, b) => ((a.order && a.order[location]) || 99) - ((b.order && b.order[location]) || 99)); // Sort top-level items
  };
};

// Export an instance of the navigationService class
export const navigationService = NavigationService.getInstance();
